var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisablePrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 8.72222H5.7C4.206 8.72222 3 9.98778 3 11.5556V17.2222H6.6V21H17.4V17.2222H21V11.5556C21 9.98778 19.794 8.72222 18.3 8.72222ZM15.6 19.1111H8.4V14.3889H15.6V19.1111ZM18.3 12.5C17.805 12.5 17.4 12.075 17.4 11.5556C17.4 11.0361 17.805 10.6111 18.3 10.6111C18.795 10.6111 19.2 11.0361 19.2 11.5556C19.2 12.075 18.795 12.5 18.3 12.5ZM17.4 4H6.6V7.77778H17.4V4Z",
    fill: "#D7D7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisablePrintIcon);
export default __webpack_public_path__ + "static/media/DisablePrintIcon.d51ba013defa4cd6393f919852b43dcc.svg";
export { ForwardRef as ReactComponent };